/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './JobInfoUpdateModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import * as _ from 'lodash';
import {
  payloadJobInfoType,
  jobInfoType,
} from '../../../interfaces/myProfile/personalDetails/jobInfo';
import CompDirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: payloadJobInfoType) => void;
  allDepartments: [];
  allEmployeeCategory: [];
  allEmployeeTypes: [];
  allContractTypes: [];
  allPayrollTypes: [];
  selectedEmployeeDetail: jobInfoType;
  trans?: any;
}

const JobInfoUpdateModalPresenter = ({
  isModalOpen,
  closeModal,
  allContractTypes,
  allDepartments,
  allEmployeeCategory,
  allEmployeeTypes,
  allPayrollTypes,
  selectedEmployeeDetail,
  callBackHandleClockIn,
  trans,
}: ModalProps) => {
  const [staffId, setStaffId] = useState(selectedEmployeeDetail.staffId);
  const [hireDate, setHireDate] = useState<any>(
    selectedEmployeeDetail.hireDate,
  );
  const [extensionNumber, setExtensionNumber] = useState(
    selectedEmployeeDetail.extNo,
  );

  const [departmentName, setDepartment] = useState(
    selectedEmployeeDetail.departmentName,
  );
  const [departmentId, setDepartmentId] = useState(
    selectedEmployeeDetail.departmentId,
  );
  const [employeeTypeId, setEmployeeTypeId] = useState(
    selectedEmployeeDetail.employeeTypeId,
  );
  const [employeeType, setEmployeeType] = useState(
    selectedEmployeeDetail.employeeType,
  );

  const [contractTypeId, setContractTypeId] = useState(
    selectedEmployeeDetail.contractTypeId,
  );
  const [contractType, setContractType] = useState(
    selectedEmployeeDetail.contractType,
  );

  const [employeeCategoryId, setEmployeeCategoryId] = useState(
    selectedEmployeeDetail.employeeCategoryId,
  );
  const [employeeCategory, setEmployeeCategory] = useState(
    selectedEmployeeDetail.employeeCategory,
  );

  const [payrollTypeId, setPayrollTypeId] = useState(
    selectedEmployeeDetail.payrollTypeId,
  );
  const [payrollType, setPayrollType] = useState(
    selectedEmployeeDetail.payrollType,
  );

  const handleSetDepartment = (deptName: any) => {
    const department = _.filter(allDepartments, function (dept: any) {
      return dept.name === deptName;
    });
    if (department.length) {
      const dept = department[0];
      setDepartmentId(dept.id);
      setDepartment(deptName);
    }
  };

  const handleSetEmployeeTypes = (type: any) => {
    const empType = _.filter(allEmployeeTypes, function (e: any) {
      return e.name === type;
    });
    if (empType.length) {
      const emp_type = empType[0];
      setEmployeeTypeId(emp_type.id);
      setEmployeeType(type);
    }
  };

  const handleSetContractType = (contractType: any) => {
    const contract_type = _.filter(allContractTypes, function (c: any) {
      return c.name === contractType;
    });
    if (contract_type.length) {
      const type = contract_type[0];
      setContractTypeId(type.id);
      setContractType(contractType);
    }
  };

  const handleSetEmployeeCategory = (empCategory: any) => {
    const category = _.filter(allEmployeeCategory, function (c: any) {
      return c.name === empCategory;
    });
    if (category.length) {
      const categ = category[0];
      setEmployeeCategoryId(categ.id);
      setEmployeeCategory(empCategory);
    }
  };

  const handleSetPayrollType = (payrollType: any) => {
    const payroll_type = _.filter(allPayrollTypes, function (c: any) {
      return c.name === payrollType;
    });
    if (payroll_type.length) {
      const type = payroll_type[0];
      setPayrollTypeId(type.id);
      setPayrollType(payrollType);
    }
  };

  const handleSubmit = () => {
    callBackHandleClockIn({
      contractType_Id: contractTypeId,
      employeeType_Id: employeeTypeId,
      employeeCategory_Id: employeeCategoryId,
      payrollType_Id: payrollTypeId,
      department_Id: departmentId,
      hire_date: hireDate,
      staff_Id: staffId,
      ext_number: extensionNumber,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Job Information') }}
        closeModal={closeModal}
      />

      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '20px',
          }}
        >
          <Grid item xs={6}>
            <CustomTextField
              type="number"
              label={trans('Staff Id')}
              placeholder={trans('Staff Id')}
              value={staffId}
              disabled={true}
              onChange={(e: any) => setStaffId(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            {' '}
            <DatePickerInput
              label={trans('Hire Date')}
              value={hireDate}
              width="100%"
              defaultValue={selectedEmployeeDetail.hireDate}
              onChange={(newValue: any) => {
                setHireDate(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Department')}
              options={_.map(allDepartments, (dept: any) => {
                return dept.name;
              })}
              value={departmentName}
              onChange={(event: any, newValue: any) => {
                handleSetDepartment(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomAutoComplete
              label={trans('Employee Type')}
              options={_.map(allEmployeeTypes, (type: any) => {
                return type.name;
              })}
              value={employeeType}
              onChange={(event: any, newValue: any) => {
                handleSetEmployeeTypes(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Contract Type')}
              options={_.map(allContractTypes, (type: any) => {
                return type.name;
              })}
              value={contractType}
              onChange={(event: any, newValue: any) => {
                handleSetContractType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomAutoComplete
              label={trans('Employee Category')}
              options={_.map(allEmployeeCategory, (type: any) => {
                return type.name;
              })}
              value={employeeCategory}
              onChange={(event: any, newValue: any) => {
                handleSetEmployeeCategory(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Payroll Type')}
              options={_.map(allPayrollTypes, (country: any) => {
                return country.name;
              })}
              value={payrollType}
              onChange={(event: any, newValue: any) => {
                handleSetPayrollType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomTextField
              type="number"
              label={trans('Extension Number')}
              placeholder={trans('Extension Number')}
              value={extensionNumber}
              onChange={(e: any) => setExtensionNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
          </Grid>
        </Grid>
      </CompDirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default JobInfoUpdateModalPresenter;
